export interface HomepageIntroduction {
    title: string
    subtitle: string
    introduction: string
    imageCaption: string
}


function state() {
    const result: HomepageIntroduction = {
        title: "智能媒体与认知实验室",
        subtitle: "清华大学，软件学院",
        introduction: "现实世界由大量复杂交互构成：从社会媒体、化学反应到生命与生态系统，许多关系并非只发生在两个对象之间，而是由多个实体共同形成。仅用孤立数据点或成对连接来建模，往往只能看见复杂系统的局部。超图为这种高阶关联提供了自然的表示与计算框架。\n智能媒体与认知实验室（iMoon Lab）聚焦人工智能、计算机视觉与数据挖掘，围绕超图计算理论、超图神经网络和超图大模型开展研究。我们将高阶关系建模应用于视觉理解、2D/3D 配准、三维场景建模、事件视觉、医学影像分析、脑网络分析、辅助诊断与病理图检索等问题，探索从复杂关联中获得更可靠、更完整的智能认知能力。",
        imageCaption: "孤立数据点与成对关系只能呈现局部；通过超图融合可观测数据与隐式高阶关联，才能形成更完整的表示并服务下游任务。"
    }
    const result_en: HomepageIntroduction = {
        title: "Intelligent Media and Cognition Lab (iMoon Lab)",
        subtitle: "School of Software, Tsinghua University",
        introduction: "The real world is shaped by complex interactions. From social media and chemical reactions to biological and ecological systems, many relationships are formed jointly by multiple entities rather than by pairs alone. Models based only on isolated data points or pairwise links often capture only part of the system. Hypergraphs provide a natural representation and computational framework for these higher-order correlations.\nThe Intelligent Media and Cognition Lab (iMoon Lab) works at the intersection of artificial intelligence, computer vision, and data mining. Our research spans hypergraph computation theory, hypergraph neural networks, and hypergraph foundation models. We apply higher-order relationship modeling to visual understanding, 2D/3D registration, 3D scene modeling, event-based vision, medical image analysis, brain-network analysis, computer-aided diagnosis, and pathology image retrieval—working toward more complete and reliable machine cognition from complex data.",
        imageCaption: "isolated observations and pairwise links reveal only fragments. Hypergraphs fuse observable data with implicit higher-order correlations to form a more complete representation for downstream tasks."
    }
    return { zh: result, en: result_en }
}

export default state()
